const PATTERN_VALIDATION = {
  email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  phone: /^(0|84|\+84)[1-9]([0-9]{8,9})$/
};

export { PATTERN_VALIDATION };
